module.exports = __webpack_public_path__ + "img/ovg-resumen-placeholder.7131e2ba.png";